import React, { createContext, useContext, useState } from 'react';
import type { Config } from '../types';
import { LoginGate } from '../components/LoginGate';
import { useSupabase } from './SupabaseContext';

const ConfigContext = createContext<Config | null>(null);

export function ConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<Config | null>(() => {
    const saved = localStorage.getItem('kmdb_config');
    return saved ? JSON.parse(saved) : null;
  });

  const { initSupabase } = useSupabase();

  const updateConfig = (newConfig: Config) => {
    initSupabase(newConfig.supabaseUrl, newConfig.supabaseAnonKey);
    localStorage.setItem('kmdb_config', JSON.stringify(newConfig));
    setConfig(newConfig);
  };

  return (
    <ConfigContext.Provider value={config}>
      {config ? (
        <>
          {children}
        </>
      ) : (
        <LoginGate onAuthorized={updateConfig} />
      )}
    </ConfigContext.Provider>
  );
}

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) throw new Error("useConfig must be used within ConfigProvider");
  return context;
};